/**
 * Unified Modal System
 *
 * Centralized modal components using the global modal stack.
 * Modals are mounted once (typically via GlobalQuickActionModals) and opened
 * from anywhere using openModal(MODAL_IDS.xxx, data).
 *
 * @example
 * ```tsx
 * import { useGlobalModalStack, MODAL_IDS } from "@west-tennessee-consulting/ui";
 *
 * export function MyComponent() {
 *   const { openModal } = useGlobalModalStack();
 *   return (
 *     <button onClick={() => openModal(MODAL_IDS.tasks.create)}>
 *       Create Task
 *     </button>
 *   );
 * }
 * ```
 */

export { UnifiedModal } from "./UnifiedModal";
export { UnifiedTaskCreationModal } from "./UnifiedTaskCreationModal";
export { DetailPageModals } from "./DetailPageModals";
